import { isFaceToFace } from '@shared/sessions/telehealth'
import { isSessionLive, SESSION_CALL_MEMBER_LEAD_MS } from '@shared/sessions/session-call'
import type { Session } from '@shared/sessions/types'

const SLACK_MS = 10 * 60_000

/**
 * Whether an incoming call from `peerEmail` could be a member-started session
 * call (a telehealth session with them whose member window is open, give or
 * take clock slack). Gates the server lookup for natively answered rings,
 * which arrive in JS without the INVITE payload.
 */
export function couldBeMemberSessionCall(
  sessions: readonly Session[],
  peerEmail: string | null | undefined,
  now: number,
): boolean {
  const email = peerEmail?.trim().toLowerCase()
  if (!email) return false
  return sessions.some(
    (s) =>
      !isFaceToFace(s) &&
      s.memberEmail?.trim().toLowerCase() === email &&
      s.lifecycleState !== 'cancelled' &&
      now >= s.start - SESSION_CALL_MEMBER_LEAD_MS - SLACK_MS &&
      (now <= s.end + SLACK_MS || isSessionLive(s.lifecycleState)),
  )
}
